export default __webpack_public_path__ + "static/Figtree-Black-8924abc3eda8fcea605d2e669a9e50fb.woff";